import Image from 'next/legacy/image';
import React from 'react';

type DeleteProps = {
  onClick?: () => void;
};

export const Delete: React.FC<DeleteProps> = ({ onClick }) => {
  return (
    <div className="flex cursor-pointer items-center text-xl" onClick={onClick}>
      <Image
        src="/assets/images/svg/delete.svg"
        alt="Delete Cart"
        width={22}
        height={17}
        className="rounded-l-lg"
      />
    </div>
  );
};
